import { Context } from "./jobs-wrapper";
import { useState, useContext } from "react";
import {cleanJobTitle, buildJobURL, removeMainCat, formatShortDate, RemovePageQSFromURL, scrollToTopOfJobs} from '../helpers/helpers.js';



const JobResults = () => {
    const {updateJobDetail, data, loading, updateJobParams, pageIndex, updatePageIndex} = useContext(Context);
    //const [pageIndex, setPageIndex] = useState(1); //page click on or currently on
    const [jobDetailWasClicked, setJobDetailWasClicked] = useState(false); 
    const [paginationParamLoaded, setPaginationParamLoaded] = useState(false); //checks if page QS loads to ensure it only runs once and avoids a loop

    
    const resultsPerPage = 20;
    const pagesToOneThousandResults = (1000/resultsPerPage);
    const dataIndex = Math.ceil(pageIndex / pagesToOneThousandResults); //grouping of results i.e., first 1k=1, second 1k=2, etc up to 10 (10k results)
    const resultsOffsetFirst = pageIndex - ((dataIndex-1) * pagesToOneThousandResults); //sets the offset num of results i.e., pageIndex3 - (dataIndex3-1) * 100
    const resultsOffset = (resultsOffsetFirst-1) * resultsPerPage; // the final offset i.e., page 1 === (1-1) * 10 = 0, page 2 === (2-1) * 10 = 10, page 3 === (3-1) * 10 = 20, 
    const urlParams = new URLSearchParams(window.location.search);
    const paginationParam = (urlParams.get('pg')) ? parseInt(urlParams.get('pg')) : null;
    //console.log("dataIndex: " +dataIndex);
    //console.log("Da Data: " + JSON.stringify(data));
    //console.log("isLoading " + loading);

    const buildPagination = (num_results, results_per_page) => {
        let num_of_pages = Math.ceil(num_results/results_per_page);
        //console.log("buildPagination curr page: " + pageIndex);

       

        if (num_results > results_per_page){
            const curr_path = window.location.pathname;
            return (
                <nav aria-label="Job Listing Page Navigation" class="job_results__pagination">
                    <ul>
                        <li>{pageIndex !== 1 ? <a href={curr_path+((pageIndex-1 !== 1) ? "?pg=" + (pageIndex-1) : "")} title="Previous Page" class="arrow_back" onClick={e => pageClick(e, (pageIndex-1))}><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow arrow-left"><path d="M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z" fill="#EBAB21"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6 8L15 11.0333L23.5429 21L15 30.9667L17.6 34L28.7429 21L17.6 8Z" fill="white"></path></svg></a> : <span class="arrow_back"></span>}</li>
                        <li>
                            <ul>
                                {
                                (() => {
                                
                                    if (num_of_pages > 5) {

                                        return(
                                            <>
                                            {(pageIndex > 2) && <li><a href={curr_path} onClick={e => pageClick(e, 1)}>1</a></li>} {/*Add first page*/}
                                            {(pageIndex > 3) && <li class="disabled"><span>&hellip;</span></li>} {/*Add elipsis*/}

                                            {/*add "3 in a row"*/}
                                            {(pageIndex === num_of_pages) && <li><a href={curr_path+"?pg=" + (pageIndex- 2)} onClick={e => pageClick(e, (pageIndex-2))}>{pageIndex- 2}</a></li>} {/*add a -2 page if max page*/}
                                            {(pageIndex > 1) && <li><a href={curr_path+((pageIndex-1 !== 1) ? "?pg=" + (pageIndex-1) : "")} onClick={e => pageClick(e, (pageIndex-1))}>{pageIndex- 1}</a></li>} {/*dont add -1 page if page 1*/}
                                            <li class="active disabled"><span>{pageIndex}</span></li>
                                            {(pageIndex < num_of_pages) && <li><a href={curr_path+"?pg=" + (pageIndex+ 1)} onClick={e => pageClick(e, (pageIndex+1))}>{pageIndex+ 1}</a></li>} {/*dont add a +1 if max page*/}
                                            {(pageIndex === 1) && <li><a href={curr_path+"?pg=" + (pageIndex + 2)} onClick={e => pageClick(e, (pageIndex+2))}>{pageIndex+ 2}</a></li>} {/*add a -2 page if page 1*/}

                                            {/*TEMP*/}
                                            {/*<li><a href="?pg=101" onClick={e => pageClick(e, 101)}>101</a></li>*/} 
                                            {/*<li><a href="?pg=999" onClick={e => pageClick(e, 999)}>999</a></li>*/} 
                                            {/*<li><a href="?pg=1001" onClick={e => pageClick(e, 1001)}>1001</a></li>*/} 
                                            {/*END TEMP*/}
                                        
                                            {
                                                pageIndex < (num_of_pages - 1) ? (
                                                    <>
                                                    {pageIndex < (num_of_pages - 2) && <li class="disabled"><span>&hellip;</span></li>}
                                                    <li><a href={curr_path+"?pg=" + num_of_pages} onClick={e => pageClick(e, num_of_pages)}>{num_of_pages}</a></li>
                                                    </>
                                                )
                                                :
                                                null
                                            }      
                                            </>
                                        )
                                    }
                                    else {
                                        let li_content = [];
                                        for (var i = 1; i <= num_of_pages; i++) {
                                            //console.log("i: " + i + ", pageIndex: " + pageIndex);
                                            const newI = i;
                                            if (i === pageIndex) {
                                                li_content.push(<li class="active disabled"><span>{pageIndex}</span></li>);
                                            } else {
                                                li_content.push(<li><a href={curr_path+"?pg=" + i} onClick={e => pageClick(e, newI)}>{i}</a></li>);
                                            }
                                        }
                                        //console.log("li_content: " + JSON.stringify(li_content));
                                        return li_content;
                                    }
                                })()  
                                }
                            </ul>
                        </li>
                        <li>{pageIndex < num_of_pages ? <a href={curr_path+"?pg=" + (pageIndex+1)} title="Next Page" class="arrow_next" onClick={e => pageClick(e, (pageIndex+1))}><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z" fill="#EBAB21"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6 8L15 11.0333L23.5429 21L15 30.9667L17.6 34L28.7429 21L17.6 8Z" fill="white"></path></svg></a> : <span class="arrow_next"></span>}</li>
                    </ul>
                </nav>
            )
        }
        else {
            return (
                <div class="job_results__pagination"></div>
            )
        }
    }  

    const pageClick = (e, selectedPageNum) => {
        if (e !== null) {
            e.preventDefault()
            RemovePageQSFromURL()
        }

        
        let dataIndexOfClickedPage =  Math.ceil(selectedPageNum / pagesToOneThousandResults) 
        //console.log("dataIndexOfClickedPage: " + dataIndexOfClickedPage);
        //console.log("dataIndex: " + dataIndex);
        //console.log("selectedPageNum: " + selectedPageNum);

        //check if the dataIndex matches the new dataIndex so we know if we're over 1k results
        if (dataIndex !== dataIndexOfClickedPage) {

            // if we're in the first 10k
            if(dataIndexOfClickedPage <= 10) { // 10 = (10k/1k)
                updateJobParams({"from" : (dataIndexOfClickedPage-1)*1000}) 
            }
            else {
                //if the suer clicks on the "next page", we can jsut grab the sort_key and return results that way. 
                if(dataIndexOfClickedPage === (dataIndex+1) && Object.keys(data).length>0) {
                    let sort_id = data.hits.hits.at(-1).sort[0]
                    updateJobParams({"from" : 0, "sort_id" : sort_id})                    
                }
                else {
                    //calculate how many times we need the api to "search after 
                    let search_afters_needed = (dataIndexOfClickedPage - 10); //calculate how many times we need the api to "search after 
                    updateJobParams({"search_after_count" : search_afters_needed}) 
                }
                
            }
            
            //setDataIndex(dataIndexOfClickedPage)
            
        }
        else {
            if (paginationParam === null) {
                //console.log("paginationParam null");

                let jobCard = document.querySelectorAll(".job-card");

                if(typeof(jobCard) != 'undefined' && jobCard != null) {
                    //reset "ective job card"
                    jobCard.forEach((el) => {
                        el.classList.remove("active-card");
                    })

                    jobCard[0].classList.add("active-card");   
                }
            }
        }
        
        setJobDetailWasClicked(false);
        updatePageIndex(selectedPageNum);
        if (paginationParam === null) {scrollToTopOfJobs();}

    }

    const jobClick = (e, row) => {
        if (window.innerWidth >= 992) {
            e.preventDefault();
            setJobDetailWasClicked(true)
            updateJobDetail(row)

            document.querySelectorAll(".job-card").forEach((el) => {
               el.classList.remove("active-card")    
            })

            e.target.closest("a").classList.add("active-card")

            //scrollToTopOfJobs()
            scrollDetailToTop()
            
        }
    }

    const buildJobInfo = (num_results, results_per_page) => {
        let num_of_pages = Math.ceil(num_results/results_per_page);

        return (
            <div class="job_results__meta">
                <span>Page {pageIndex} of {num_of_pages}</span> | <span>{num_results} Jobs Found</span>
            </div>
        )
    }

    const scrollDetailToTop = () => {
        if (document.getElementsByClassName("job_results__details-content")) {
            document.getElementsByClassName("job_results__details-content")[0].scrollTo(0, 0);
        }
    }
    const addNoJobsBodyClass = () => {
        if (!document.body.classList.contains('no-jobs-found')) {
            document.body.classList.add('no-jobs-found');
        }
    }
    const removeNoJobsBodyClass = () => {
        if (document.body.classList.contains('no-jobs-found')) {
            document.body.classList.remove('no-jobs-found');
        }
    }
    const buildAdditionalJobNotFoundMarkup = () => {
        return (
            <section class="green-footer-tout">
                <div class="container-xl">  
                    <div class="row justify-content-center">
                        <div class="col-lg-10 col-xl-8">
                            <a href="/quick-apply/" title="Quick Apply">    
                                <h3>Find More Opportunities to Shine</h3>
                                <span class="link-arrow-yellow-text link-large">Quick Apply</span>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    if(loading) {
        return (
            <div class="jobs-loading"><img src="/wp-content/themes/sunbelt/images/loading.gif" alt="" /><span>Loading..</span></div>
        )
    }
    else {
        if (paginationParam !== null && !isNaN(paginationParam) && paginationParamLoaded === false) {
            //logic for pg=x QS 
            setPaginationParamLoaded(true) //set to true so when this re-renders, it renders the HTML in the else if below
            pageClick(null, paginationParam) //set page 
        }
        else if((typeof data.hits !== 'undefined' && data.hits.total.value > 0 && paginationParam <= Math.ceil(data?.aggregations['job_count']["value"]/resultsPerPage))) {
            document.getElementById('job-detail') != null && (document.getElementById('job-detail').style.display = 'block') //show job detail
            removeNoJobsBodyClass() //removes no jobs found body class if it exists
            return (
                
                <div class="col-lg-4">
                    <div id="job_results__list">
                    {/*console.log("new pageIndex: " + pageIndex)*/}
                    {/*!loading && console.log("total jobs count using facet: " + data.aggregations['job_count']["value"])*/}
                    {/*!loading && console.log(data.hits.hits)*/}
                    {buildJobInfo(data.aggregations['job_count']["value"], resultsPerPage)}
                    {
                        /** 
                        * to get right "offset" of pages, we need to (pageIndex-1 * resultsPerPage) so:
                        * page 1 will be (1-1) * 10 = offet 0 => pull results 0-9
                        * page 2 will be (2-1) * 10 = offet 10 => pull results 10-19
                        * page 3 will be (3-1) * 10 = offet 20 => pull results 20-29
                        **/
                    }
                    {data.hits.hits?.slice(resultsOffset).map((row, index) => (  
                        
                            index < resultsPerPage && ( // <= show only x items 
                                //job_category, job_city, job_state, job_zip, job_id
                                <a href={buildJobURL(row.fields.job_category[0], row.fields.job_city[0], row.fields.job_state_abbr[0], row.fields.job_postal[0], row.fields.job_order_id[0])} class={(index===0) ? "job-card active-card" : "job-card"} title={cleanJobTitle(row.fields.job_title[0])} onClick={e => jobClick(e, row.fields)} data-id={row.fields.job_order_id[0]}>
                                    <h5>{cleanJobTitle(row.fields.job_title[0])}</h5>
                                    {/*console.log("Index: " + index)*/}
                                    <div class="job-card__meta">
                                        <span class="job-card__loc">{row.fields.job_city[0]}, {row.fields.job_state_abbr[0]}</span> 
                                        <span class="job-card__discipline">{removeMainCat(row.fields.job_category[0])}</span> 
                                        <span class="job-card__posted-date">{formatShortDate(row.fields.modified_at[0])}</span>
                                    </div>
                                </a>
                            
                            )
                    ))}
                    
                    {buildPagination(data.aggregations['job_count']["value"], resultsPerPage)}
                    {(jobDetailWasClicked===false && window.innerWidth >= 769) && updateJobDetail(data.hits.hits[resultsOffset]?.fields) /* set first result to the job detail data to appear */} 
                    {/*(!loading && !Object.keys(jobDetail).length>0) && console.log("JobDetails ON RENDER: " + JSON.stringify(jobDetail))*/}
                    {/*(paginationParam !== null || !isNaN(paginationParam)) && pageClick(null, paginationParam) /* check for page params */}
                    </div>
                    <a href="/quick-apply/" class="simple-green-tout hide-on-desktop-lg" title="Quick Apply">
                    <h3>Haven’t Found The Right Fit?</h3>
                    <h5>Submit your resume and we’ll find a place for you to shine.</h5>
                    <span class="link-arrow-white">Quick Apply</span>
                    </a>
                </div>
        
        
            )
        }
        else {
            document.getElementById('job-detail') != null && (document.getElementById('job-detail').style.display = 'none') //hide job detail
            addNoJobsBodyClass() //this adds a body class if no jobs are found
                return(
                    <div class="col-lg-10">
                        <div class="no-jobs">
                            <img src="/wp-content/themes/sunbelt/images/icons/job-seeker.svg" alt="No jobs were found" />
                            <h2>Sorry, we didn’t find any jobs matching your criteria.</h2>
                            <ul>
                                <li>Make sure the city and state are spelled correctly</li>
                                <li>Replace abbreviations with the entire word</li>
                                <li>Broaden your filter options.</li>
                            </ul>
                        </div>
                    </div>  
                )
         
        }
    } 

}

export default JobResults;



